import styled, { css } from "styled-components";

export const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

type AdSlotProps = { isPreview?: boolean; forcePreview: boolean };
// postcss-styled-components-disable-next-line
export const AdSlot = styled.div<AdSlotProps>`
  ${(props: AdSlotProps) =>
    (props.isPreview || props.forcePreview) && PreviewCss}
`;

const PreviewCss = css<AdSlotProps>`
  background-color: rgb(0, 0, 0, 0.01);
  border: 1px dashed rgb(0, 0, 0, 0.1);
  text-align: center;
  &:after {
    content: ${(props: AdSlotProps): string =>
      props.forcePreview ? '"Anzeige"' : '"Preview"'};
    color: rgb(0, 0, 0, 0.3);
  }
`;
